import { Progress, Stack, Text } from '@chakra-ui/react';
import React from 'react';
export const ProgressBar = (props)=>{
    const { label , value , ...flexProps } = props;
    return /*#__PURE__*/ React.createElement(Stack, {
        spacing: 1,
        ...flexProps
    }, label && /*#__PURE__*/ React.createElement(Text, {
        color: "text.secondary",
        textStyle: "xs"
    }, label), /*#__PURE__*/ React.createElement(Progress, {
        value: value
    }));
};

//# sourceMappingURL=progress-bar.js.map